export const APP_NAME = 'StandUp';
export const APP_VERSION = '1.4.2';
export const BUILD_NUMBER = 16;
